import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalXlarge};
  padding: ${tokens.spacing.verticalMedium} ${tokens.spacing.horizontalLarge};
`

export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: ${tokens.spacing.verticalXsmall};
`

export const Title = styled.span`
  font-size: ${tokens.fontSize.large};
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark6};
  line-height: ${tokens.lineHeight.medium}%;
`

export const Subtitle = styled.span`
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.regular};
  color: ${tokens.colors.dark6};
  line-height: ${tokens.lineHeight.medium}%;
`

export const ListJobs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${tokens.spacing.verticalSmall};
  width: 100%;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const JobOptionCard = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: ${tokens.spacing.horizontalMedium};
  gap: ${tokens.spacing.horizontalXsmall};
  width: 100%;
  flex-grow: 1;
  border: 1px solid
    ${({ isSelected }) =>
      isSelected ? tokens.colors.livros : tokens.colors.dark3};
  border-radius: ${tokens.radius.medium};
`

export const JobOptionInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 217px;
  gap: ${tokens.spacing.verticalXxsmall};
  flex-grow: 1;
`

export const JobOptionTitle = styled.span`
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.regular};
  color: ${tokens.colors.dark6};
  line-height: ${tokens.lineHeight.medium}%;
`

export const JobOptionDescription = styled.span`
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.regular};
  color: ${tokens.colors.dark5};
  line-height: ${tokens.lineHeight.medium}%;
`

export const WrapperFooter = styled.div`
  display: flex;
  gap: ${tokens.spacing.verticalMedium};
  width: 100%;
  justify-content: flex-end;
  padding-right: ${tokens.spacing.horizontalLarge};
  padding-bottom: 64px;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    padding-bottom: 0px;
  }
`
